"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsServices = exports.trackEvent = exports.setBaseEventAttributes = exports.clearUser = exports.setUserId = exports.initUserAnalytics = void 0;
const amplitudeService_1 = __importDefault(require("./amplitudeService"));
const planhatService_1 = __importDefault(require("./planhatService"));
let baseEventAttributes;
var AnalyticsServices;
(function (AnalyticsServices) {
    AnalyticsServices["AMPLITUDE"] = "amplitude";
    AnalyticsServices["PLANHAT"] = "planhat";
})(AnalyticsServices || (AnalyticsServices = {}));
exports.AnalyticsServices = AnalyticsServices;
const initUserAnalytics = (options) => {
    amplitudeService_1.default.initialize(options);
    planhatService_1.default.initialize(options);
};
exports.initUserAnalytics = initUserAnalytics;
const setUserId = (userId) => {
    amplitudeService_1.default.setUserId(userId);
    planhatService_1.default.setUserId(userId);
};
exports.setUserId = setUserId;
const setBaseEventAttributes = (attributes) => {
    baseEventAttributes = attributes;
};
exports.setBaseEventAttributes = setBaseEventAttributes;
const clearUser = () => {
    amplitudeService_1.default.clearUser();
    planhatService_1.default.clearUser();
};
exports.clearUser = clearUser;
const trackEvent = (eventName, eventAttributes, options) => {
    const finalEventAttributes = Object.assign(Object.assign({}, baseEventAttributes), { eventAttributes });
    amplitudeService_1.default.trackEvent(eventName, finalEventAttributes);
    planhatService_1.default.trackEvent(eventName, finalEventAttributes, options === null || options === void 0 ? void 0 : options.planhatMajorAttributes);
};
exports.trackEvent = trackEvent;
//# sourceMappingURL=analytics.js.map